import { useState, useEffect } from 'react';
import DataTable from '../DataTable/DataTable';

const API = process.env.REACT_APP_API_URL;
const pillClass = { Approved: 'pill-approved', Pending: 'pill-pending', Rejected: 'pill-rejected' };

function renderStars(rating) {
  const filled = Math.round(rating);
  return '★'.repeat(filled) + '☆'.repeat(5 - filled) + ` (${rating})`;
}

export default function Reviews({ showToast }) {
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchReviews(); }, []);

  const fetchReviews = () => {
    setLoading(true);
  fetch(`${API}/reviews?admin=1`)
      .then(r => r.json())
      .then(data => { setRows(data); setLoading(false); })
      .catch(() => { showToast('Load Failed', 'Could not load reviews.'); setLoading(false); });
  };

  const handleApprove = async (id) => {
    try {
      const res = await fetch(`${API}/reviews/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'Approved' }),
      });
      if (res.ok) {
        setRows(prev => prev.map(r => r.id === id ? { ...r, status: 'Approved' } : r));
        showToast('Approved!', 'Review approved successfully.');
      }
    } catch { showToast('Server Error', 'Something went wrong. Try again.'); }
  };

  const handleReject = async (id) => {
    try {
      const res = await fetch(`${API}/reviews/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'Rejected' }),
      });
      if (res.ok) {
        setRows(prev => prev.map(r => r.id === id ? { ...r, status: 'Rejected' } : r));
        showToast('Rejected!', 'Review has been rejected.');
      }
    } catch { showToast('Server Error', 'Something went wrong. Try again.'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this review?')) return;
    try {
      const res = await fetch(`${API}/reviews/${id}`, { method: 'DELETE' });
      if (res.ok) {
        setRows(prev => prev.filter(r => r.id !== id));
        showToast('Deleted!', 'Review removed successfully.');
      }
    } catch { showToast('Server Error', 'Something went wrong. Try again.'); }
  };



  return (
    <div>
      {/* Header */}
      <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div className="section-title">Customer Reviews</div>
      
      </div>

    
      {/* Table */}
      {loading ? (
        <p style={{ padding: 20, color: '#6B7280' }}>Loading reviews...</p>
      ) : rows.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#6B7280' }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>💬</div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>No reviews yet</div>
          <div style={{ fontSize: 13, marginTop: 4 }}>Customer reviews will appear here once submitted</div>
        </div>
      ) : (
        <DataTable
          columns={['ID', 'Customer', 'Feedback', 'Rating', 'Status', 'Actions']}
          initialRows={rows}
          renderRow={(row) => (
            <tr key={row.id}>
              <td style={{ fontWeight: 600, color: '#6B7280' }}>#{row.id}</td>
              <td style={{ fontWeight: 600 }}>
                {row.Customer?.name || row.guestName || 'Guest'}
              </td>
              <td style={{ maxWidth: 300, color: '#374151', fontSize: 13 }}>
                {row.feedback}
              </td>
              <td style={{ color: '#F59E0B', fontWeight: 700, fontSize: 15, whiteSpace: 'nowrap' }}>
                {renderStars(row.rating)}
              </td>
              <td>
                <span className={`status-pill ${pillClass[row.status]}`}>{row.status}</span>
              </td>
              <td>
                <div style={{ display: 'flex', gap: 6 }}>
                  {row.status !== 'Approved' && (
                    <button
                      className="action-btn btn-approve"
                      onClick={() => handleApprove(row.id)}
                    >
                      Approve
                    </button>
                  )}
                  {row.status !== 'Rejected' && (
                    <button
                      onClick={() => handleReject(row.id)}
                      style={{ padding: '5px 10px', background: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: 6, color: '#EA580C', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                    >
                      Reject
                    </button>
                  )}
                  <button
                    className="action-btn btn-del"
                    onClick={() => handleDelete(row.id)}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          )}
        />
      )}
    </div>
  );
}